import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { isValidElement } from "react";
import { localizationService } from "services/localization-service";

export function LynxDialog(props) {
  const handleClose = (e, reason) => {
    if (reason == "backdropClick" && !props.closeOnBackdropClick) {
      return;
    }
    props.handleClose();
  };

  return (
    <Dialog
      open={props.open}
      maxWidth={props.maxWidth ?? "sm"}
      fullWidth={props.fullWidth ?? false}
      onClose={handleClose}
      className="lynx-dialog"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={props.isCloseInHeader ? { paddingRight: 7 } : {}}
      >
        {props.title}
        {props.isCloseInHeader ? (
          <IconButton
            aria-label={localizationService.getLocalizedString(
              "screen.dialogs.close"
            )}
            onClick={props.handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>

      <DialogContent dividers={props.dividers}>
        {props.dialogContent ? (
          props.dialogContent
        ) : isValidElement(props.description) ? (
          props.description
        ) : (
          <DialogContentText id="alert-dialog-description">
            {props.description}
          </DialogContentText>
        )}
      </DialogContent>
      {!props.hasNoActions && (
        <DialogActions>
          {((props.handleClose && !props.isCloseInHeader) ||
            props.handleCancel) && (
            <Button
              onClick={props.handleClose ?? props.handleCancel}
              color={props.handleCancel ? "error" : "primary"}
              variant="contained"
            >
              {localizationService.getLocalizedString("screen.buttons.cancel")}
            </Button>
          )}

          {props.handleDelete && !props.disableDelete && (
            <Button
              onClick={props.handleDelete}
              variant="contained"
              color="error"
              className="confirm-delete-button"
            >
              {props.deleteButtonText ??
                localizationService.getLocalizedString("screen.buttons.delete")}
            </Button>
          )}
          {props.handleConfirm && (
            <Button
              onClick={props.handleConfirm}
              variant="contained"
              color="success"
              sx={{ color: "white" }}
              disabled={props.confirmDisabled}
            >
              {props.okButtonText ??
                localizationService.getLocalizedString("screen.buttons.ok")}
            </Button>
          )}
          {props.handleSave && (
            <Button
              onClick={props.handleSave}
              variant="contained"
              color={props.saveButtonColor ?? "primary"}
              sx={{ color: "white" }}
              disabled={props.saveDisabled}
            >
              {props.saveButtonText ??
                localizationService.getLocalizedString("screen.buttons.save")}
            </Button>
          )}
          {props.handleDownload && (
            <Button
              onClick={props.handleDownload}
              variant="contained"
              color="success"
            >
              {localizationService.getLocalizedString(
                "screen.buttons.download"
              )}
            </Button>
          )}
          {props.buttons && <props.buttons />}
        </DialogActions>
      )}
    </Dialog>
  );
}
